import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import type { CoinType } from '../../stores/cointype/CoinTypeStore';
import { SocialCoin } from '../SocialCoin/SocialCoin';
import { SweepCoin } from '../SweepCoin/SweepCoin';

import classes from './CoinWithValue.module.scss';

export type CoinWithValue = PropsWithChildren<{
  coinType: CoinType;
  coinSide?: 'left' | 'right' | 'top';
  coinWidth?: number | string;
  className?: string;
  dataTestId?: string;
  valueDataTestId?: string;
  isPile?: boolean;
  valueClassName?: string;
}>;

export function CoinWithValue({
  coinType,
  children,
  coinSide = 'right',
  coinWidth,
  className,
  dataTestId,
  valueDataTestId,
  valueClassName,
  isPile = false,
}: CoinWithValue) {
  const CurrentCoinIcon = coinType === 'GC' ? SocialCoin : SweepCoin;

  return (
    <div
      className={classNames(
        classes.coinWithValue,
        { [classes.top]: coinSide === 'top' },
        { [classes.left]: coinSide === 'left' },
        { [classes.right]: coinSide === 'right' },
        className,
      )}
      data-testid={dataTestId}
    >
      <div className={classNames(classes.value, valueClassName)} data-testid={valueDataTestId}>
        {children}
      </div>
      <div className={classes.coin} style={{ width: coinWidth }}>
        <CurrentCoinIcon className={classes.coinImg} isPile={isPile} />
      </div>
    </div>
  );
}
